import React from 'react';
import { InstagramIcon, MailIcon } from 'lucide-react';
import { contactEmail, instagramUrl, productName } from '../data/content';
export function Footer() {
  return <footer className="border-t border-white/10 bg-teal-950 px-4 py-12" data-id="element-89" data-mp="3gh3n22klrk9c">
      <div className="mx-auto max-w-4xl text-center" data-id="element-90" data-mp="32pp764lzrz6i">
        <p className="text-base font-black uppercase tracking-[.2em] text-amber-300" data-id="element-91" data-mp="36oxw8w6378vq">Bright Digital Hub</p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/75" data-id="element-92" data-mp="3uesbtlhsjbjo">
          Professional digital resources for physical therapists, physiotherapists, and geriatric rehabilitation
          specialists.
        </p>
        <p className="mt-5 text-sm font-black uppercase text-white" data-id="element-93" data-mp="3le2iqpjwzz9n">{productName}</p>
        <div className="mt-5 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-white/80 sm:flex-row sm:gap-6" data-id="element-94" data-mp="3qc3yp1m1nigw">
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-amber-300" href={`mailto:${contactEmail}`} data-id="element-95" data-mp="2a1jjpa3jzw2z">
            <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-96" data-mp="3lbmtfq7jj4eu" /> {contactEmail}
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors duration-150 ease-out hover:text-amber-300" href={instagramUrl} target="_blank" rel="noopener noreferrer" data-id="element-97" data-mp="3gca5f24xnrao">
            <InstagramIcon className="h-4 w-4" aria-hidden="true" data-id="element-98" data-mp="82qp7jv45dpi" /> Bright Digital Hub
          </a>
        </div>
        <div className="mt-8 space-y-2 border-t border-white/10 pt-6 text-xs text-white/60" data-id="element-99" data-mp="34patc8mu2kd">
          <p data-id="element-100" data-mp="htd0j1vsri2e">© 2026 Bright Digital Hub — All Rights Reserved.</p>
          <p data-id="element-101" data-mp="huo6978syzw5">
            This material is intended for professional educational and reference purposes. It does not replace
            appropriate professional training, individualized clinical assessment, medical diagnosis, or healthcare
            treatment.
          </p>
          <p data-id="element-102" data-mp="mtrcgv0irc5p">
            All rehabilitation interventions must be selected and adapted by qualified professionals according to
            patient needs, clinical judgment, and safety requirements.
          </p>
          <p data-id="element-103" data-mp="ys3gsil2z725">Unauthorized reproduction, resale, or redistribution is prohibited without express permission.</p>
        </div>
      </div>
    </footer>;
}